// Boarding ticket texts (Escuna Aquamarina II; TOUR_COPY below adds the other chey tours), shared by the site (src/i18n/local/<lang>/boardingPass.ts) and the
// confirmation email sent by the server (ticketEmail.mjs), so both always say the same thing.
// Placeholders use i18next's {{name}} syntax; `_one` / `_other` are i18next plurals.
import { CHEY_TOURS, pickupFor } from './cheyTours.mjs';

export const TICKET_COPY = {
  pt: {
    confirmed: 'Reserva confirmada',
    pending: 'Aguardando pagamento',
    cancelled: 'Reserva cancelada',
    tour: 'Passeio de Escuna Aquamarina II',
    intro: 'Roteiro sul pelas ilhas e praias de Paraty, com 4 paradas para banho de mar e mergulho livre, escorregador triplo, Wi-Fi Starlink e bar e restaurante a bordo. Cerca de 5 horas de passeio.',
    holder: 'Titular da reserva',
    date: 'Data',
    departure: 'Saída',
    checkin: 'Check-in',
    checkinTime: '9h00 – 10h50',
    adults: 'Adultos',
    children: 'Crianças',
    babies: 'Bebês',
    meetingPoint: 'Ponto de encontro',
    meetingPlace: 'Cais de Turismo de Paraty',
    qrTitle: 'QR de embarque',
    qrHint: 'Mostre este código no check-in.',
    qrIssuing: 'Emitindo seu QR de embarque…',
    qrIssuingHint: 'Leva só alguns segundos.',
    qrFailed: 'Seu QR de embarque chega no seu email em instantes.',
    qrFailedHint: 'No check-in também localizamos sua reserva pelo nome do titular.',
    qrOff: 'Apresente este ticket no check-in: localizamos sua reserva pelo nome do titular.',
    voucher: 'Voucher',
    reservation: 'Reserva',
    howTitle: 'Como encontrar a escuna',
    how1: 'Vá até o Cais de Turismo de Paraty.',
    how2: 'Siga até o final do flutuante de madeira (o píer).',
    how3: 'Procure a escuna AQUAMARINA II, mostre seu QR no check-in e pronto: você já está a bordo com a gente!',
    infoTitle: 'Informações importantes',
    infoArrive: 'Chegue com antecedência: o check-in vai das 9h00 às 10h50 e os lugares a bordo são ocupados por ordem de chegada.',
    infoTab: 'No check-in você recebe um número de comanda para o bar e o restaurante. A conta é paga no fim do passeio com Pix, cartão de débito ou crédito (inclusive Amex) ou dinheiro.',
    infoChange: 'Troca de data sem custo até 24 horas antes do início do passeio.',
    infoRefund: 'Cancelamento: com 7 dias ou mais de antecedência, reembolso integral; entre 7 dias e 48 horas antes, retenção de 20% do valor pago (reembolso de 80%); com menos de 48 horas ou no-show, não há reembolso. Se a empresa cancelar por segurança, clima ou motivos operacionais, você remarca ou recebe o reembolso de 100%.',
    infoWeather: 'O roteiro pode mudar por causa do vento, das condições do mar ou de outros fatores de segurança. No traslado de bote até a praia e fora da embarcação, seus pertences ficam sob sua responsabilidade.',
    total: 'Total da reserva',
    paid: 'Sinal pago',
    due: 'A pagar a bordo',
    download: 'Baixar PDF',
    downloading: 'Gerando PDF…',
    openVoucher: 'Voucher da escuna',
    footer: 'AQUAMARINA TOURS · aquamarinatours.art · Bom passeio!',
    confirming: {
      title: 'Confirmando seu embarque',
      subtitle: 'Estamos registrando sua reserva no sistema da escuna e gerando seu QR de check-in.',
      step1: 'Pagamento Pix confirmado',
      step2: 'Reservando seu lugar na Escuna Aquamarina II',
      step3: 'Emitindo o voucher de embarque',
      step4: 'Gerando seu QR de check-in',
      slow: 'Quase lá: o sistema da escuna está respondendo. Pode deixar esta página aberta.',
      done: 'Tudo pronto! Seu embarque está confirmado.',
    },
    live: {
      checking: 'Consultando vagas em tempo real…',
      available: 'Vagas disponíveis nesta data',
      few_one: 'Última vaga nesta data!',
      few_other: 'Últimas {{count}} vagas nesta data!',
      soldOut: 'Esgotado nesta data. Escolha outra data.',
      closed: 'A escuna não sai nesta data. Escolha outra data.',
      closedTour: 'Sem vagas online nesta data. Escolha outra data ou fale com a gente pelo WhatsApp.',
      notEnough_one: 'Resta só {{count}} vaga nesta data.',
      notEnough_other: 'Restam só {{count}} vagas nesta data.',
    },
    email: {
      subject: 'Reserva confirmada · Escuna Aquamarina II · {{date}}',
      preheader: 'Seu QR de embarque e tudo o que você precisa para o dia do passeio.',
      greeting: 'Olá, {{name}}!',
      lead: 'Seu pagamento foi aprovado e sua reserva está confirmada. Guarde este email: no dia, é só mostrar o QR no check-in.',
      openTicket: 'Abrir meu ticket',
      qrLater: 'Seu QR de embarque está sendo emitido e aparece no seu ticket online em instantes.',
      attached: 'Seu ticket também vai em PDF, anexado a este email.',
      help: 'Alguma dúvida? Responda este email ou fale com a gente pelo WhatsApp.',
    },
    boatLabel: 'Embarcação',
    review: {
      status: 'Confirmando reserva',
      checking: 'Confirmando sua reserva…',
      title: 'Estamos confirmando sua reserva',
      lead: 'Recebemos seu pagamento de {{paid}}. Agora estamos confirmando seu lugar no passeio.',
      // Booked with the team, nothing paid yet.
      leadBooked: 'Recebemos sua reserva. Agora estamos confirmando seu lugar no passeio.',
      body: 'Assim que estiver tudo certo, seu ticket com o QR de embarque aparece nesta página e chega no seu email. Costuma levar pouco tempo; se precisarmos de algo, falamos com você pelo WhatsApp.',
      whatsapp: 'Falar com a gente no WhatsApp',
      rejectedStatus: 'Sem lugares',
      rejectedTitle: 'Não há mais lugares para esta data',
      rejectedLead: 'Sentimos muito, {{name}}. Os lugares deste passeio se esgotaram na data escolhida e não conseguimos garantir o seu.',
      rejectedRefund: 'Já devolvemos seu Pix de {{amount}}. O valor volta para a conta de onde você pagou, normalmente na hora (em alguns bancos pode levar até 1 dia útil).',
      rejectedNext: 'Vamos adorar receber você em outra data: escolha um novo dia ou fale com a gente pelo WhatsApp.',
      otherDates: 'Escolher outra data',
      emailSubject: 'Sem lugares em {{date}} · Pix devolvido · {{tour}}',
      emailPreheader: 'Os lugares se esgotaram nesta data e devolvemos seu Pix.',
      // A booking made with the team (nothing paid online): no refund to announce.
      emailSubjectNoRefund: 'Sem lugares em {{date}} · {{tour}}',
      emailPreheaderNoRefund: 'Os lugares se esgotaram nesta data.',
    },
  },
  es: {
    confirmed: 'Reserva confirmada',
    pending: 'Pago pendiente',
    cancelled: 'Reserva cancelada',
    tour: 'Paseo en barco Aquamarina II',
    intro: 'Ruta sur por las islas y playas de Paraty, con 4 paradas para bañarse y hacer snorkel, tobogán triple, Wi-Fi Starlink y bar y restaurante a bordo. Unas 5 horas de paseo.',
    holder: 'Titular de la reserva',
    date: 'Fecha',
    departure: 'Salida',
    checkin: 'Check-in',
    checkinTime: '9:00 – 10:50',
    adults: 'Adultos',
    children: 'Niños',
    babies: 'Bebés',
    meetingPoint: 'Punto de encuentro',
    meetingPlace: 'Muelle de Turismo de Paraty (Cais de Turismo)',
    qrTitle: 'QR de embarque',
    qrHint: 'Muestra este código en el check-in.',
    qrIssuing: 'Emitiendo tu QR de embarque…',
    qrIssuingHint: 'Tarda solo unos segundos.',
    qrFailed: 'Tu QR de embarque te llega por email en unos instantes.',
    qrFailedHint: 'En el check-in también encontramos tu reserva por el nombre del titular.',
    qrOff: 'Presenta este ticket en el check-in: encontramos tu reserva por el nombre del titular.',
    voucher: 'Voucher',
    reservation: 'Reserva',
    howTitle: 'Cómo encontrar el barco',
    how1: 'Ve al Cais de Turismo (muelle de turismo) de Paraty.',
    how2: 'Camina hasta el final del muelle flotante de madera.',
    how3: 'Busca el barco AQUAMARINA II, muestra tu QR en el check-in y listo: ¡ya estás a bordo con nosotros!',
    infoTitle: 'Información importante',
    infoArrive: 'Llega con anticipación: el check-in es de 9:00 a 10:50 y los lugares a bordo se ocupan por orden de llegada.',
    infoTab: 'En el check-in recibes un número de comanda para el bar y el restaurante. La cuenta se paga al final del paseo con Pix, tarjeta de débito o crédito (incluida Amex) o efectivo.',
    infoChange: 'Puedes cambiar la fecha sin costo hasta 24 horas antes del inicio del paseo.',
    infoRefund: 'Cancelación: con 7 días o más de anticipación, reembolso total; entre 7 días y 48 horas antes, se retiene el 20% del valor pagado (reembolso del 80%); con menos de 48 horas o no-show, no hay reembolso. Si la empresa cancela por seguridad, clima o motivos operativos, puedes reprogramar o recibir el reembolso del 100%.',
    infoWeather: 'El itinerario puede cambiar por el viento, el estado del mar u otros motivos de seguridad. En el traslado en bote hasta la playa y fuera del barco, tus pertenencias quedan bajo tu responsabilidad.',
    total: 'Total de la reserva',
    paid: 'Seña pagada',
    due: 'A pagar a bordo',
    download: 'Descargar PDF',
    downloading: 'Generando PDF…',
    openVoucher: 'Voucher del barco',
    footer: 'AQUAMARINA TOURS · aquamarinatours.art · ¡Buen paseo!',
    confirming: {
      title: 'Confirmando tu embarque',
      subtitle: 'Estamos registrando tu reserva en el sistema del barco y generando tu QR de check-in.',
      step1: 'Pago Pix confirmado',
      step2: 'Reservando tu lugar en el barco Aquamarina II',
      step3: 'Emitiendo el voucher de embarque',
      step4: 'Generando tu QR de check-in',
      slow: 'Casi listo: el sistema del barco está respondiendo. Puedes dejar esta página abierta.',
      done: '¡Todo listo! Tu embarque está confirmado.',
    },
    live: {
      checking: 'Consultando lugares en tiempo real…',
      available: 'Lugares disponibles en esta fecha',
      few_one: '¡Último lugar en esta fecha!',
      few_other: '¡Últimos {{count}} lugares en esta fecha!',
      soldOut: 'Agotado en esta fecha. Elige otra fecha.',
      closed: 'El barco no sale en esta fecha. Elige otra fecha.',
      closedTour: 'Sin lugares online en esta fecha. Elige otra fecha o escríbenos por WhatsApp.',
      notEnough_one: 'Queda solo {{count}} lugar en esta fecha.',
      notEnough_other: 'Quedan solo {{count}} lugares en esta fecha.',
    },
    email: {
      subject: 'Reserva confirmada · Barco Aquamarina II · {{date}}',
      preheader: 'Tu QR de embarque y todo lo que necesitas para el día del paseo.',
      greeting: '¡Hola, {{name}}!',
      lead: 'Tu pago fue aprobado y tu reserva está confirmada. Guarda este email: el día del paseo solo tienes que mostrar el QR en el check-in.',
      openTicket: 'Abrir mi ticket',
      qrLater: 'Tu QR de embarque se está emitiendo y aparecerá en tu ticket online en unos instantes.',
      attached: 'Tu ticket también va en PDF, adjunto a este email.',
      help: '¿Alguna duda? Responde este email o escríbenos por WhatsApp.',
    },
    boatLabel: 'Embarcación',
    review: {
      status: 'Confirmando reserva',
      checking: 'Confirmando tu reserva…',
      title: 'Estamos confirmando tu reserva',
      lead: 'Recibimos tu pago de {{paid}}. Ahora estamos confirmando tu lugar en el paseo.',
      leadBooked: 'Recibimos tu reserva. Ahora estamos confirmando tu lugar en el paseo.',
      body: 'En cuanto esté todo listo, tu ticket con el QR de embarque aparecerá en esta página y te llegará por email. Suele tardar poco; si necesitamos algo, te escribimos por WhatsApp.',
      whatsapp: 'Escríbenos por WhatsApp',
      rejectedStatus: 'Sin lugares',
      rejectedTitle: 'Ya no quedan lugares para esta fecha',
      rejectedLead: 'Lo sentimos mucho, {{name}}. Los lugares de este paseo se agotaron en la fecha que elegiste y no pudimos asegurar el tuyo.',
      rejectedRefund: 'Ya te devolvimos tu Pix de {{amount}}. El dinero vuelve a la cuenta desde la que pagaste, normalmente al instante (en algunos bancos puede tardar hasta 1 día hábil).',
      rejectedNext: 'Nos encantará recibirte en otra fecha: elige un nuevo día o escríbenos por WhatsApp.',
      otherDates: 'Elegir otra fecha',
      emailSubject: 'Sin lugares el {{date}} · Pix devuelto · {{tour}}',
      emailPreheader: 'Los lugares se agotaron en esta fecha y te devolvimos tu Pix.',
      emailSubjectNoRefund: 'Sin lugares el {{date}} · {{tour}}',
      emailPreheaderNoRefund: 'Los lugares se agotaron en esta fecha.',
    },
  },
  en: {
    confirmed: 'Booking confirmed',
    pending: 'Awaiting payment',
    cancelled: 'Booking cancelled',
    tour: 'Aquamarina II Schooner Tour',
    intro: 'South route through the islands and beaches of Paraty: 4 stops for swimming and snorkelling, a triple slide, Starlink Wi-Fi and a bar and restaurant on board. About 5 hours.',
    holder: 'Booking holder',
    date: 'Date',
    departure: 'Departure',
    checkin: 'Check-in',
    checkinTime: '9:00 – 10:50 am',
    adults: 'Adults',
    children: 'Children',
    babies: 'Babies',
    meetingPoint: 'Meeting point',
    meetingPlace: 'Paraty Tourism Pier (Cais de Turismo)',
    qrTitle: 'Boarding QR',
    qrHint: 'Show this code at check-in.',
    qrIssuing: 'Issuing your boarding QR…',
    qrIssuingHint: 'It only takes a few seconds.',
    qrFailed: 'Your boarding QR will reach you by email in a moment.',
    qrFailedHint: 'At check-in we can also find your booking by the holder’s name.',
    qrOff: 'Show this ticket at check-in: we find your booking by the holder’s name.',
    voucher: 'Voucher',
    reservation: 'Booking',
    howTitle: 'How to find the schooner',
    how1: 'Go to the Tourism Pier (Cais de Turismo) in Paraty.',
    how2: 'Walk to the very end of the floating wooden pier.',
    how3: 'Look for the schooner AQUAMARINA II, show your QR at check-in and that’s it: you’re on board with us!',
    infoTitle: 'Good to know',
    infoArrive: 'Arrive early: check-in runs from 9:00 to 10:50 am and seats on board are first come, first served.',
    infoTab: 'At check-in you get a tab number for the bar and restaurant. You settle it at the end of the tour by Pix, debit or credit card (Amex included) or cash.',
    infoChange: 'Change your date free of charge up to 24 hours before the tour starts.',
    infoRefund: 'Cancellations: 7 days or more ahead, full refund; between 7 days and 48 hours before, 20% of the amount paid is withheld (80% refunded); less than 48 hours before or no-show, no refund. If we cancel for safety, weather or operational reasons, you can rebook or get a 100% refund.',
    infoWeather: 'The route may change because of wind, sea conditions or other safety reasons. During the dinghy transfer to the beach and once you are off the boat, your belongings are your own responsibility.',
    total: 'Booking total',
    paid: 'Deposit paid',
    due: 'To pay on board',
    download: 'Download PDF',
    downloading: 'Creating PDF…',
    openVoucher: 'Schooner voucher',
    footer: 'AQUAMARINA TOURS · aquamarinatours.art · Enjoy the ride!',
    confirming: {
      title: 'Confirming your boarding',
      subtitle: 'We’re registering your booking with the schooner and creating your check-in QR.',
      step1: 'Pix payment confirmed',
      step2: 'Reserving your seat on the Aquamarina II',
      step3: 'Issuing your boarding voucher',
      step4: 'Creating your check-in QR',
      slow: 'Almost there: the schooner’s system is answering. You can keep this page open.',
      done: 'All set! Your boarding is confirmed.',
    },
    live: {
      checking: 'Checking live availability…',
      available: 'Seats available on this date',
      few_one: 'Last seat on this date!',
      few_other: 'Last {{count}} seats on this date!',
      soldOut: 'Sold out on this date. Please pick another date.',
      closed: 'The schooner does not sail on this date. Please pick another date.',
      closedTour: 'No online seats on this date. Please pick another date or message us on WhatsApp.',
      notEnough_one: 'Only {{count}} seat left on this date.',
      notEnough_other: 'Only {{count}} seats left on this date.',
    },
    email: {
      subject: 'Booking confirmed · Aquamarina II Schooner · {{date}}',
      preheader: 'Your boarding QR and everything you need for the day of the tour.',
      greeting: 'Hi {{name}}!',
      lead: 'Your payment was approved and your booking is confirmed. Keep this email: on the day, just show the QR at check-in.',
      openTicket: 'Open my ticket',
      qrLater: 'Your boarding QR is being issued and will appear on your online ticket in a moment.',
      attached: 'Your ticket is also attached to this email as a PDF.',
      help: 'Any questions? Reply to this email or message us on WhatsApp.',
    },
    boatLabel: 'Boat',
    review: {
      status: 'Confirming booking',
      checking: 'Confirming your booking…',
      title: 'We’re confirming your booking',
      lead: 'We received your payment of {{paid}}. We’re now confirming your place on the tour.',
      leadBooked: 'We received your booking. We’re now confirming your place on the tour.',
      body: 'As soon as everything is set, your ticket with the boarding QR will appear on this page and arrive by email. It usually doesn’t take long; if we need anything, we’ll message you on WhatsApp.',
      whatsapp: 'Message us on WhatsApp',
      rejectedStatus: 'Sold out',
      rejectedTitle: 'There are no more places on this date',
      rejectedLead: 'We’re very sorry, {{name}}. This tour sold out on the date you chose and we couldn’t secure your place.',
      rejectedRefund: 'We’ve already refunded your Pix of {{amount}}. The money goes back to the account you paid from, usually instantly (some banks take up to 1 business day).',
      rejectedNext: 'We’d love to welcome you on another day: pick a new date or message us on WhatsApp.',
      otherDates: 'Choose another date',
      emailSubject: 'Sold out on {{date}} · Pix refunded · {{tour}}',
      emailPreheader: 'This date sold out and we’ve refunded your Pix.',
      emailSubjectNoRefund: 'Sold out on {{date}} · {{tour}}',
      emailPreheaderNoRefund: 'This date sold out.',
    },
  },
  fr: {
    confirmed: 'Réservation confirmée',
    pending: 'Paiement en attente',
    cancelled: 'Réservation annulée',
    tour: 'Balade en goélette Aquamarina II',
    intro: 'Route sud parmi les îles et plages de Paraty : 4 arrêts baignade et snorkeling, toboggan triple, Wi-Fi Starlink, bar et restaurant à bord. Environ 5 heures de balade.',
    holder: 'Titulaire de la réservation',
    date: 'Date',
    departure: 'Départ',
    checkin: 'Enregistrement',
    checkinTime: '9h00 – 10h50',
    adults: 'Adultes',
    children: 'Enfants',
    babies: 'Bébés',
    meetingPoint: 'Point de rendez-vous',
    meetingPlace: 'Quai du tourisme de Paraty (Cais de Turismo)',
    qrTitle: 'QR d’embarquement',
    qrHint: 'Présentez ce code à l’enregistrement.',
    qrIssuing: 'Émission de votre QR d’embarquement…',
    qrIssuingHint: 'Cela ne prend que quelques secondes.',
    qrFailed: 'Votre QR d’embarquement vous arrive par email dans un instant.',
    qrFailedHint: 'À l’enregistrement, nous retrouvons aussi votre réservation au nom du titulaire.',
    qrOff: 'Présentez ce billet à l’enregistrement : nous retrouvons votre réservation au nom du titulaire.',
    voucher: 'Voucher',
    reservation: 'Réservation',
    howTitle: 'Comment trouver la goélette',
    how1: 'Rendez-vous au quai du tourisme (Cais de Turismo) de Paraty.',
    how2: 'Allez jusqu’au bout du ponton flottant en bois.',
    how3: 'Cherchez la goélette AQUAMARINA II, montrez votre QR à l’enregistrement et c’est tout : vous êtes à bord avec nous !',
    infoTitle: 'Informations importantes',
    infoArrive: 'Arrivez en avance : l’enregistrement a lieu de 9h00 à 10h50 et les places à bord sont attribuées par ordre d’arrivée.',
    infoTab: 'À l’enregistrement, vous recevez un numéro de note pour le bar et le restaurant, à régler en fin de balade par Pix, carte de débit ou de crédit (Amex acceptée) ou en espèces.',
    infoChange: 'Changement de date gratuit jusqu’à 24 heures avant le début de la balade.',
    infoRefund: 'Annulation : 7 jours ou plus avant, remboursement intégral ; entre 7 jours et 48 heures avant, retenue de 20 % du montant payé (remboursement de 80 %) ; moins de 48 heures avant ou no-show, aucun remboursement. Si nous annulons pour des raisons de sécurité, de météo ou d’exploitation, vous pouvez reporter ou être remboursé à 100 %.',
    infoWeather: 'L’itinéraire peut changer en raison du vent, de l’état de la mer ou d’autres motifs de sécurité. Pendant le transfert en annexe jusqu’à la plage et une fois hors du bateau, vos affaires restent sous votre responsabilité.',
    total: 'Total de la réservation',
    paid: 'Acompte payé',
    due: 'À payer à bord',
    download: 'Télécharger le PDF',
    downloading: 'Création du PDF…',
    openVoucher: 'Voucher de la goélette',
    footer: 'AQUAMARINA TOURS · aquamarinatours.art · Bonne balade !',
    confirming: {
      title: 'Confirmation de votre embarquement',
      subtitle: 'Nous enregistrons votre réservation auprès de la goélette et créons votre QR d’enregistrement.',
      step1: 'Paiement Pix confirmé',
      step2: 'Réservation de votre place sur l’Aquamarina II',
      step3: 'Émission de votre voucher d’embarquement',
      step4: 'Création de votre QR d’enregistrement',
      slow: 'Presque fini : le système de la goélette répond. Vous pouvez laisser cette page ouverte.',
      done: 'Tout est prêt ! Votre embarquement est confirmé.',
    },
    live: {
      checking: 'Vérification des places en temps réel…',
      available: 'Places disponibles à cette date',
      few_one: 'Dernière place à cette date !',
      few_other: 'Plus que {{count}} places à cette date !',
      soldOut: 'Complet à cette date. Choisissez une autre date.',
      closed: 'La goélette ne sort pas à cette date. Choisissez une autre date.',
      closedTour: 'Plus de places en ligne à cette date. Choisissez une autre date ou écrivez-nous sur WhatsApp.',
      notEnough_one: 'Il ne reste que {{count}} place à cette date.',
      notEnough_other: 'Il ne reste que {{count}} places à cette date.',
    },
    email: {
      subject: 'Réservation confirmée · Goélette Aquamarina II · {{date}}',
      preheader: 'Votre QR d’embarquement et tout ce qu’il faut pour le jour de la balade.',
      greeting: 'Bonjour {{name}} !',
      lead: 'Votre paiement a été approuvé et votre réservation est confirmée. Gardez cet email : le jour J, il suffit de montrer le QR à l’enregistrement.',
      openTicket: 'Ouvrir mon billet',
      qrLater: 'Votre QR d’embarquement est en cours d’émission et apparaîtra sur votre billet en ligne dans un instant.',
      attached: 'Votre billet est aussi joint à cet email en PDF.',
      help: 'Une question ? Répondez à cet email ou écrivez-nous sur WhatsApp.',
    },
    boatLabel: 'Bateau',
    review: {
      status: 'Confirmation en cours',
      checking: 'Confirmation de votre réservation…',
      title: 'Nous confirmons votre réservation',
      lead: 'Nous avons bien reçu votre paiement de {{paid}}. Nous confirmons maintenant votre place pour la balade.',
      leadBooked: 'Nous avons bien reçu votre réservation. Nous confirmons maintenant votre place pour la balade.',
      body: 'Dès que tout est prêt, votre billet avec le QR d’embarquement apparaîtra sur cette page et vous parviendra par email. Cela prend généralement peu de temps ; si nous avons besoin de quoi que ce soit, nous vous écrirons sur WhatsApp.',
      whatsapp: 'Nous écrire sur WhatsApp',
      rejectedStatus: 'Complet',
      rejectedTitle: 'Il n’y a plus de places à cette date',
      rejectedLead: 'Nous sommes vraiment désolés, {{name}}. Cette balade est complète à la date choisie et nous n’avons pas pu vous garantir une place.',
      rejectedRefund: 'Nous vous avons déjà remboursé votre Pix de {{amount}}. L’argent revient sur le compte qui a servi au paiement, généralement immédiatement (certaines banques mettent jusqu’à 1 jour ouvré).',
      rejectedNext: 'Nous serions ravis de vous accueillir un autre jour : choisissez une nouvelle date ou écrivez-nous sur WhatsApp.',
      otherDates: 'Choisir une autre date',
      emailSubject: 'Complet le {{date}} · Pix remboursé · {{tour}}',
      emailPreheader: 'Cette date est complète et nous avons remboursé votre Pix.',
      emailSubjectNoRefund: 'Complet le {{date}} · {{tour}}',
      emailPreheaderNoRefund: 'Cette date est complète.',
    },
  },
};

/**
 * What changes on the tickets of the other chey tours (Saco do Mamanguá, the two jeep tours); everything else
 * is the same as on the Escuna Aquamarina II's. Merged by ticketCopyFor.
 */
export const TOUR_COPY = {
  mamangua: {
    pt: {
      tour: 'Passeio de Lancha pelo Saco do Mamanguá',
      live: { closed: 'A lancha não sai nesta data. Escolha outra data.' },
      intro: 'O único fiorde tropical do Brasil, de lancha rápida: Ilha dos Cocos, Praia do Engenho, Praia do Cruzeiro e Ilha do Mantimento, com paradas para banho e mergulho com máscara. Cerca de 6 horas de passeio.',
      checkin: 'Chegada',
      checkinTime: '15 min antes',
      meetingPlace: 'Cais de Turismo de Paraty (Centro Histórico)',
      qrHint: 'Mostre este código no embarque.',
      qrFailedHint: 'No embarque também localizamos sua reserva pelo nome do titular.',
      qrOff: 'Apresente este ticket no embarque: localizamos sua reserva pelo nome do titular.',
      howTitle: 'Como encontrar a lancha',
      how1: 'Vá até o Cais de Turismo de Paraty, no Centro Histórico, 15 minutos antes da saída.',
      how2: 'Na entrada do cais, procure o guia da lancha: ele também fala com você pelo WhatsApp.',
      how3: 'Mostre seu QR no embarque e pronto: o fiorde tropical espera por você!',
      infoArrive: 'Chegue 15 minutos antes da saída: a lancha sai no horário marcado.',
      infoTab: 'A bordo há coletes salva-vidas, máscaras de mergulho e cooler com gelo para suas bebidas e lanches. Não é permitido levar cooler próprio. O almoço na Praia do Cruzeiro é opcional e pago no local.',
      infoWeather: 'O roteiro pode mudar por causa do vento, das condições do mar ou de outros fatores de segurança. Evite roupas largas: venta bastante durante a navegação.',
      due: 'A pagar no dia',
      openVoucher: 'Voucher da lancha',
      confirming: {
        subtitle: 'Estamos registrando sua reserva no sistema da lancha e gerando seu QR de embarque.',
        step2: 'Reservando seu lugar na lancha',
        step4: 'Gerando seu QR de embarque',
        slow: 'Quase lá: o sistema da lancha está respondendo. Pode deixar esta página aberta.',
      },
      email: {
        subject: 'Reserva confirmada · Saco do Mamanguá · {{date}}',
        lead: 'Seu pagamento foi aprovado e sua reserva está confirmada. Guarde este email: no dia, é só mostrar o QR no embarque.',
      },
    },
    es: {
      tour: 'Paseo en lancha por el Saco do Mamanguá',
      live: { closed: 'La lancha no sale en esta fecha. Elige otra fecha.' },
      intro: 'El único fiordo tropical de Brasil, en lancha rápida: Ilha dos Cocos, Praia do Engenho, Praia do Cruzeiro e Ilha do Mantimento, con paradas para bañarse y hacer snorkel. Unas 6 horas de paseo.',
      checkin: 'Llegada',
      checkinTime: '15 min antes',
      meetingPlace: 'Cais de Turismo de Paraty (Centro Histórico)',
      qrHint: 'Muestra este código al embarcar.',
      qrFailedHint: 'Al embarcar también encontramos tu reserva por el nombre del titular.',
      qrOff: 'Presenta este ticket al embarcar: encontramos tu reserva por el nombre del titular.',
      howTitle: 'Cómo encontrar la lancha',
      how1: 'Ve al Cais de Turismo (muelle de turismo) de Paraty, en el Centro Histórico, 15 minutos antes de la salida.',
      how2: 'En la entrada del muelle, busca al guía de la lancha: también te escribe por WhatsApp.',
      how3: 'Muestra tu QR al embarcar y listo: ¡el fiordo tropical te espera!',
      infoArrive: 'Llega 15 minutos antes de la salida: la lancha sale a la hora indicada.',
      infoTab: 'A bordo hay chalecos salvavidas, máscaras de snorkel y una nevera con hielo para tus bebidas y snacks. No se permite llevar nevera propia. El almuerzo en la Praia do Cruzeiro es opcional y se paga en el lugar.',
      infoWeather: 'El itinerario puede cambiar por el viento, el estado del mar u otros motivos de seguridad. Evita la ropa holgada: hay mucho viento durante la navegación.',
      due: 'A pagar el día del paseo',
      openVoucher: 'Voucher de la lancha',
      confirming: {
        subtitle: 'Estamos registrando tu reserva en el sistema de la lancha y generando tu QR de embarque.',
        step2: 'Reservando tu lugar en la lancha',
        step4: 'Generando tu QR de embarque',
        slow: 'Casi listo: el sistema de la lancha está respondiendo. Puedes dejar esta página abierta.',
      },
      email: {
        subject: 'Reserva confirmada · Saco do Mamanguá · {{date}}',
        lead: 'Tu pago fue aprobado y tu reserva está confirmada. Guarda este email: el día del paseo solo tienes que mostrar el QR al embarcar.',
      },
    },
    en: {
      tour: 'Saco do Mamanguá Speedboat Tour',
      live: { closed: 'The boat does not go out on this date. Please pick another date.' },
      intro: 'Brazil’s only tropical fjord by speedboat: Ilha dos Cocos, Praia do Engenho, Praia do Cruzeiro and Ilha do Mantimento, with stops to swim and snorkel. About 6 hours.',
      checkin: 'Arrive',
      checkinTime: '15 min early',
      meetingPlace: 'Paraty Tourist Pier (Cais de Turismo, Historic Center)',
      qrHint: 'Show this code when boarding.',
      qrFailedHint: 'When boarding we can also find your booking by the lead guest’s name.',
      qrOff: 'Show this ticket when boarding: we find your booking by the lead guest’s name.',
      howTitle: 'How to find the boat',
      how1: 'Go to Paraty’s Tourist Pier (Cais de Turismo) in the Historic Center, 15 minutes before departure.',
      how2: 'At the pier entrance, look for the boat’s guide: they’ll also message you on WhatsApp.',
      how3: 'Show your QR when boarding and that’s it: the tropical fjord is waiting!',
      infoArrive: 'Arrive 15 minutes before departure: the boat leaves on time.',
      infoTab: 'On board there are life jackets, snorkel masks and an ice cooler for your drinks and snacks. Bringing your own cooler is not allowed. Lunch at Praia do Cruzeiro is optional and paid on site.',
      infoWeather: 'The route may change because of wind, sea conditions or other safety reasons. Avoid loose clothing: it gets windy while sailing.',
      due: 'To pay on the day',
      openVoucher: 'Boat voucher',
      confirming: {
        subtitle: 'We’re registering your booking in the boat’s system and generating your boarding QR.',
        step2: 'Booking your place on the boat',
        step4: 'Generating your boarding QR',
        slow: 'Almost there: the boat’s system is responding. You can keep this page open.',
      },
      email: {
        subject: 'Booking confirmed · Saco do Mamanguá · {{date}}',
        lead: 'Your payment was approved and your booking is confirmed. Keep this email: on the day, just show the QR when boarding.',
      },
    },
    fr: {
      tour: 'Balade en bateau rapide au Saco do Mamanguá',
      live: { closed: 'La vedette ne sort pas à cette date. Choisissez une autre date.' },
      intro: 'Le seul fjord tropical du Brésil en bateau rapide : Ilha dos Cocos, Praia do Engenho, Praia do Cruzeiro et Ilha do Mantimento, avec des arrêts baignade et snorkeling. Environ 6 heures.',
      checkin: 'Arrivée',
      checkinTime: '15 min avant',
      meetingPlace: 'Quai touristique de Paraty (Cais de Turismo, centre historique)',
      qrHint: 'Montrez ce code à l’embarquement.',
      qrFailedHint: 'À l’embarquement, nous retrouvons aussi votre réservation au nom du titulaire.',
      qrOff: 'Présentez ce billet à l’embarquement : nous retrouvons votre réservation au nom du titulaire.',
      howTitle: 'Comment trouver le bateau',
      how1: 'Rendez-vous au quai touristique de Paraty (Cais de Turismo), dans le centre historique, 15 minutes avant le départ.',
      how2: 'À l’entrée du quai, cherchez le guide du bateau : il vous écrit aussi sur WhatsApp.',
      how3: 'Montrez votre QR à l’embarquement et c’est parti : le fjord tropical vous attend !',
      infoArrive: 'Arrivez 15 minutes avant le départ : le bateau part à l’heure.',
      infoTab: 'À bord : gilets de sauvetage, masques de snorkeling et glacière avec de la glace pour vos boissons et en-cas. Il est interdit d’apporter sa propre glacière. Le déjeuner à la Praia do Cruzeiro est facultatif et se paie sur place.',
      infoWeather: 'L’itinéraire peut changer en raison du vent, de l’état de la mer ou d’autres motifs de sécurité. Évitez les vêtements amples : il y a beaucoup de vent pendant la navigation.',
      due: 'À payer le jour même',
      openVoucher: 'Voucher du bateau',
      confirming: {
        subtitle: 'Nous enregistrons votre réservation dans le système du bateau et générons votre QR d’embarquement.',
        step2: 'Réservation de votre place sur le bateau',
        step4: 'Génération de votre QR d’embarquement',
        slow: 'Presque prêt : le système du bateau répond. Vous pouvez laisser cette page ouverte.',
      },
      email: {
        subject: 'Réservation confirmée · Saco do Mamanguá · {{date}}',
        lead: 'Votre paiement a été approuvé et votre réservation est confirmée. Gardez cet email : le jour J, il suffit de montrer le QR à l’embarquement.',
      },
    },
  },
  mataAtlantica: {
    pt: {
      departure: 'Saída',
      pickupLabel: 'Busca',
      agencyLabel: 'Chegada na agência',
      pickupPoint: 'Busca em',
      agencyPoint: 'Embarque na agência',
      pickupPlaceDefault: 'Sua hospedagem (centro de Paraty, até 3 km da agência)',
      agencyPlace: 'Agência Paraty Sirena Tours – Av. Roberto Silveira, 578',
      howTitle: 'Como funciona a busca',
      howTitleAgency: 'Como funciona o embarque',
      howHotel1: 'Esteja pronto na sua hospedagem a partir das {{from}}: a busca vai até as {{departure}}.',
      howHotel2: 'O guia confirma pelo WhatsApp o horário exato em que passa por você.',
      howAgency1: 'Chegue à agência Paraty Sirena Tours (Av. Roberto Silveira, 578) às {{arrive}}, {{lead}} minutos antes da saída das {{departure}}.',
      howAgency2: 'Na agência, o guia faz o check-in do grupo.',
      arriveHotel: 'Esteja pronto a partir das {{from}}: o jeep passa por outras hospedagens no caminho e sai às {{departure}}.',
      arriveAgency: 'Chegue à agência às {{arrive}} ({{lead}} minutos antes da saída): o jeep sai às {{departure}} em ponto.',
      tour: 'Passeio de Jeep pela Mata Atlântica',
      live: { closed: 'O jeep não sai nesta data. Escolha outra data.' },
      intro: 'Jeep 4x4 pelas cachoeiras de Paraty: Cachoeira Pedra Branca, Poço do Tarzan, alambiques do Caminho do Ouro e Casa de Farinha, com guia local. Cerca de 6 horas de passeio.',
      qrHint: 'Mostre este código ao guia no embarque.',
      qrFailedHint: 'No embarque o guia também localiza sua reserva pelo nome do titular.',
      qrOff: 'Apresente este ticket ao guia: ele localiza sua reserva pelo nome do titular.',
      how3: 'Mostre seu QR ao guia ao subir no jeep e pronto: bora para as cachoeiras!',
      infoTab: 'Vá com roupa de banho por baixo e calçado com boa aderência (tênis ou sapatilha aquática). Leve toalha, protetor solar, repelente e água. Almoço e degustações não estão inclusos.',
      infoWeather: 'A ordem das paradas pode mudar conforme o clima e o volume de água das cachoeiras. Crianças sempre acompanhadas por um responsável.',
      due: 'A pagar no dia',
      openVoucher: 'Voucher do passeio',
      confirming: {
        subtitle: 'Estamos registrando sua reserva no sistema do passeio e gerando seu QR de embarque.',
        step2: 'Reservando seu lugar no jeep',
        step4: 'Gerando seu QR de embarque',
        slow: 'Quase lá: o sistema do passeio está respondendo. Pode deixar esta página aberta.',
      },
      email: {
        subject: 'Reserva confirmada · Jeep pela Mata Atlântica · {{date}}',
        lead: 'Seu pagamento foi aprovado e sua reserva está confirmada. Guarde este email: no dia, é só mostrar o QR ao guia.',
      },
    },
    es: {
      departure: 'Salida',
      pickupLabel: 'Recogida',
      agencyLabel: 'Llegada a la agencia',
      pickupPoint: 'Recogida en',
      agencyPoint: 'Embarque en la agencia',
      pickupPlaceDefault: 'Tu alojamiento (centro de Paraty, hasta 3 km de la agencia)',
      agencyPlace: 'Agencia Paraty Sirena Tours – Av. Roberto Silveira, 578',
      howTitle: 'Cómo funciona la recogida',
      howTitleAgency: 'Cómo funciona el embarque',
      howHotel1: 'Está listo en tu alojamiento desde las {{from}}: la recogida es hasta las {{departure}}.',
      howHotel2: 'El guía te confirma por WhatsApp la hora exacta en que pasa por ti.',
      howAgency1: 'Llega a la agencia Paraty Sirena Tours (Av. Roberto Silveira, 578) a las {{arrive}}, {{lead}} minutos antes de la salida de las {{departure}}.',
      howAgency2: 'En la agencia, el guía hace el check-in del grupo.',
      arriveHotel: 'Está listo desde las {{from}}: el jeep pasa por otros alojamientos en el camino y sale a las {{departure}}.',
      arriveAgency: 'Llega a la agencia a las {{arrive}} ({{lead}} minutos antes de la salida): el jeep sale a las {{departure}} en punto.',
      tour: 'Paseo en jeep por la Mata Atlántica',
      live: { closed: 'El jeep no sale en esta fecha. Elige otra fecha.' },
      intro: 'Jeep 4x4 por las cascadas de Paraty: Cachoeira Pedra Branca, Poço do Tarzan, destilerías del Camino del Oro y Casa de Farinha, con guía local. Unas 6 horas de paseo.',
      qrHint: 'Muestra este código al guía al subir.',
      qrFailedHint: 'Al subir, el guía también encuentra tu reserva por el nombre del titular.',
      qrOff: 'Presenta este ticket al guía: encuentra tu reserva por el nombre del titular.',
      how3: 'Muestra tu QR al guía al subir al jeep y listo: ¡a las cascadas!',
      infoTab: 'Ve con traje de baño debajo y calzado con buen agarre (zapatillas o escarpines). Lleva toalla, protector solar, repelente y agua. El almuerzo y las degustaciones no están incluidos.',
      infoWeather: 'El orden de las paradas puede cambiar según el clima y el caudal de las cascadas. Los niños siempre acompañados por un responsable.',
      due: 'A pagar el día del paseo',
      openVoucher: 'Voucher del paseo',
      confirming: {
        subtitle: 'Estamos registrando tu reserva en el sistema del paseo y generando tu QR de embarque.',
        step2: 'Reservando tu lugar en el jeep',
        step4: 'Generando tu QR de embarque',
        slow: 'Casi listo: el sistema del paseo está respondiendo. Puedes dejar esta página abierta.',
      },
      email: {
        subject: 'Reserva confirmada · Jeep por la Mata Atlántica · {{date}}',
        lead: 'Tu pago fue aprobado y tu reserva está confirmada. Guarda este email: el día del paseo solo tienes que mostrar el QR al guía.',
      },
    },
    en: {
      departure: 'Departure',
      pickupLabel: 'Pick-up',
      agencyLabel: 'Be at the agency',
      pickupPoint: 'Pick-up at',
      agencyPoint: 'Boarding at the agency',
      pickupPlaceDefault: 'Your lodging (central Paraty, up to 3 km from the agency)',
      agencyPlace: 'Paraty Sirena Tours agency – Av. Roberto Silveira, 578',
      howTitle: 'How the pick-up works',
      howTitleAgency: 'How boarding works',
      howHotel1: 'Be ready at your lodging from {{from}}: pick-ups run until {{departure}}.',
      howHotel2: 'The guide confirms on WhatsApp the exact time they come for you.',
      howAgency1: 'Be at the Paraty Sirena Tours agency (Av. Roberto Silveira, 578) at {{arrive}}, {{lead}} minutes before the {{departure}} departure.',
      howAgency2: 'At the agency, the guide checks the group in.',
      arriveHotel: 'Be ready from {{from}}: the jeep picks up at other lodgings on the way and leaves at {{departure}}.',
      arriveAgency: 'Be at the agency at {{arrive}} ({{lead}} minutes before departure): the jeep leaves at {{departure}} sharp.',
      tour: 'Atlantic Forest Jeep Tour',
      live: { closed: 'The jeep does not go out on this date. Please pick another date.' },
      intro: '4x4 jeep to Paraty’s waterfalls: Pedra Branca Waterfall, Poço do Tarzan, Gold Road distilleries and a cassava flour house, with a local guide. About 6 hours.',
      qrHint: 'Show this code to the guide when boarding.',
      qrFailedHint: 'When boarding, the guide can also find your booking by the lead guest’s name.',
      qrOff: 'Show this ticket to the guide: they find your booking by the lead guest’s name.',
      how3: 'Show your QR to the guide as you get in the jeep and off you go to the waterfalls!',
      infoTab: 'Wear swimwear underneath and shoes with good grip (sneakers or water shoes). Bring a towel, sunscreen, insect repellent and water. Lunch and tastings are not included.',
      infoWeather: 'The order of the stops may change with the weather and the waterfalls’ flow. Children must always be with an adult.',
      due: 'To pay on the day',
      openVoucher: 'Tour voucher',
      confirming: {
        subtitle: 'We’re registering your booking in the tour’s system and generating your boarding QR.',
        step2: 'Booking your place in the jeep',
        step4: 'Generating your boarding QR',
        slow: 'Almost there: the tour’s system is responding. You can keep this page open.',
      },
      email: {
        subject: 'Booking confirmed · Atlantic Forest Jeep Tour · {{date}}',
        lead: 'Your payment was approved and your booking is confirmed. Keep this email: on the day, just show the QR to the guide.',
      },
    },
    fr: {
      departure: 'Départ',
      pickupLabel: 'Prise en charge',
      agencyLabel: 'Arrivée à l’agence',
      pickupPoint: 'Prise en charge à',
      agencyPoint: 'Embarquement à l’agence',
      pickupPlaceDefault: 'Votre hébergement (centre de Paraty, jusqu’à 3 km de l’agence)',
      agencyPlace: 'Agence Paraty Sirena Tours – Av. Roberto Silveira, 578',
      howTitle: 'Comment se passe la prise en charge',
      howTitleAgency: 'Comment se passe l’embarquement',
      howHotel1: 'Soyez prêt à votre hébergement dès {{from}} : la prise en charge se fait jusqu’à {{departure}}.',
      howHotel2: 'Le guide vous confirme sur WhatsApp l’heure exacte de son passage.',
      howAgency1: 'Soyez à l’agence Paraty Sirena Tours (Av. Roberto Silveira, 578) à {{arrive}}, {{lead}} minutes avant le départ de {{departure}}.',
      howAgency2: 'À l’agence, le guide enregistre le groupe.',
      arriveHotel: 'Soyez prêt dès {{from}} : le jeep passe par d’autres hébergements en chemin et part à {{departure}}.',
      arriveAgency: 'Soyez à l’agence à {{arrive}} ({{lead}} minutes avant le départ) : le jeep part à {{departure}} précises.',
      tour: 'Balade en jeep dans la forêt atlantique',
      live: { closed: 'Le jeep ne sort pas à cette date. Choisissez une autre date.' },
      intro: 'En jeep 4x4 vers les cascades de Paraty : Cachoeira Pedra Branca, Poço do Tarzan, distilleries du Chemin de l’Or et Casa de Farinha, avec un guide local. Environ 6 heures.',
      qrHint: 'Montrez ce code au guide à l’embarquement.',
      qrFailedHint: 'À l’embarquement, le guide retrouve aussi votre réservation au nom du titulaire.',
      qrOff: 'Présentez ce billet au guide : il retrouve votre réservation au nom du titulaire.',
      how3: 'Montrez votre QR au guide en montant dans le jeep et c’est parti pour les cascades !',
      infoTab: 'Portez votre maillot de bain dessous et des chaussures qui accrochent (baskets ou chaussons d’eau). Apportez serviette, crème solaire, anti-moustique et eau. Le déjeuner et les dégustations ne sont pas inclus.',
      infoWeather: 'L’ordre des arrêts peut changer selon la météo et le débit des cascades. Les enfants doivent toujours être accompagnés d’un adulte.',
      due: 'À payer le jour même',
      openVoucher: 'Voucher de la balade',
      confirming: {
        subtitle: 'Nous enregistrons votre réservation dans le système de la balade et générons votre QR d’embarquement.',
        step2: 'Réservation de votre place dans le jeep',
        step4: 'Génération de votre QR d’embarquement',
        slow: 'Presque prêt : le système de la balade répond. Vous pouvez laisser cette page ouverte.',
      },
      email: {
        subject: 'Réservation confirmée · Jeep dans la forêt atlantique · {{date}}',
        lead: 'Votre paiement a été approuvé et votre réservation est confirmée. Gardez cet email : le jour J, il suffit de montrer le QR au guide.',
      },
    },
  },
  trindade: {
    pt: {
      departure: 'Saída',
      pickupLabel: 'Busca',
      agencyLabel: 'Chegada na agência',
      pickupPoint: 'Busca em',
      agencyPoint: 'Embarque na agência',
      pickupPlaceDefault: 'Sua hospedagem (centro de Paraty, até 3 km da agência)',
      agencyPlace: 'Agência Paraty Sirena Tours – Av. Roberto Silveira, 578',
      howTitle: 'Como funciona a busca',
      howTitleAgency: 'Como funciona o embarque',
      howHotel1: 'Esteja pronto na sua hospedagem a partir das {{from}}: a busca vai até as {{departure}}.',
      howHotel2: 'O guia confirma pelo WhatsApp o horário exato em que passa por você.',
      howAgency1: 'Chegue à agência Paraty Sirena Tours (Av. Roberto Silveira, 578) às {{arrive}}, {{lead}} minutos antes da saída das {{departure}}.',
      howAgency2: 'Na agência, o guia faz o check-in do grupo.',
      arriveHotel: 'Esteja pronto a partir das {{from}}: o jeep passa por outras hospedagens no caminho e sai às {{departure}}.',
      arriveAgency: 'Chegue à agência às {{arrive}} ({{lead}} minutos antes da saída): o jeep sai às {{departure}} em ponto.',
      tour: 'Passeio às Praias de Trindade',
      live: { closed: 'O jeep não sai nesta data. Escolha outra data.' },
      intro: 'O melhor de Trindade em um dia: Praia do Meio, Praia dos Ranchos, Praia do Cachadaço e a Piscina Natural, com parada final na queijaria. Van e jeep com guia local. Cerca de 6 horas de passeio.',
      qrHint: 'Mostre este código ao guia no embarque.',
      qrFailedHint: 'No embarque o guia também localiza sua reserva pelo nome do titular.',
      qrOff: 'Apresente este ticket ao guia: ele localiza sua reserva pelo nome do titular.',
      how3: 'Mostre seu QR ao guia no embarque e pronto: as praias de Trindade esperam por você!',
      infoTab: 'Almoço não incluso (restaurante na Praia dos Ranchos). A travessia de barco até a Piscina Natural é opcional e paga no local (R$ 25 ida + R$ 25 volta); a trilha até lá leva uns 45 minutos.',
      infoWeather: 'O roteiro pode mudar por causa do clima ou do mar. Leve roupa de banho, tênis para trilha leve, protetor solar, toalha e água.',
      due: 'A pagar no dia',
      openVoucher: 'Voucher do passeio',
      confirming: {
        subtitle: 'Estamos registrando sua reserva no sistema do passeio e gerando seu QR de embarque.',
        step2: 'Reservando seu lugar no passeio',
        step4: 'Gerando seu QR de embarque',
        slow: 'Quase lá: o sistema do passeio está respondendo. Pode deixar esta página aberta.',
      },
      email: {
        subject: 'Reserva confirmada · Praias de Trindade · {{date}}',
        lead: 'Seu pagamento foi aprovado e sua reserva está confirmada. Guarde este email: no dia, é só mostrar o QR ao guia.',
      },
    },
    es: {
      departure: 'Salida',
      pickupLabel: 'Recogida',
      agencyLabel: 'Llegada a la agencia',
      pickupPoint: 'Recogida en',
      agencyPoint: 'Embarque en la agencia',
      pickupPlaceDefault: 'Tu alojamiento (centro de Paraty, hasta 3 km de la agencia)',
      agencyPlace: 'Agencia Paraty Sirena Tours – Av. Roberto Silveira, 578',
      howTitle: 'Cómo funciona la recogida',
      howTitleAgency: 'Cómo funciona el embarque',
      howHotel1: 'Está listo en tu alojamiento desde las {{from}}: la recogida es hasta las {{departure}}.',
      howHotel2: 'El guía te confirma por WhatsApp la hora exacta en que pasa por ti.',
      howAgency1: 'Llega a la agencia Paraty Sirena Tours (Av. Roberto Silveira, 578) a las {{arrive}}, {{lead}} minutos antes de la salida de las {{departure}}.',
      howAgency2: 'En la agencia, el guía hace el check-in del grupo.',
      arriveHotel: 'Está listo desde las {{from}}: el jeep pasa por otros alojamientos en el camino y sale a las {{departure}}.',
      arriveAgency: 'Llega a la agencia a las {{arrive}} ({{lead}} minutos antes de la salida): el jeep sale a las {{departure}} en punto.',
      tour: 'Paseo a las playas de Trindade',
      live: { closed: 'El jeep no sale en esta fecha. Elige otra fecha.' },
      intro: 'Lo mejor de Trindade en un día: Praia do Meio, Praia dos Ranchos, Praia do Cachadaço y la Piscina Natural, con parada final en la quesería. Van y jeep con guía local. Unas 6 horas de paseo.',
      qrHint: 'Muestra este código al guía al subir.',
      qrFailedHint: 'Al subir, el guía también encuentra tu reserva por el nombre del titular.',
      qrOff: 'Presenta este ticket al guía: encuentra tu reserva por el nombre del titular.',
      how3: 'Muestra tu QR al guía al subir y listo: ¡las playas de Trindade te esperan!',
      infoTab: 'El almuerzo no está incluido (restaurante en la Praia dos Ranchos). El cruce en barco hasta la Piscina Natural es opcional y se paga en el lugar (R$ 25 ida + R$ 25 vuelta); el sendero hasta allí lleva unos 45 minutos.',
      infoWeather: 'El itinerario puede cambiar por el clima o el mar. Lleva traje de baño, zapatillas para un sendero fácil, protector solar, toalla y agua.',
      due: 'A pagar el día del paseo',
      openVoucher: 'Voucher del paseo',
      confirming: {
        subtitle: 'Estamos registrando tu reserva en el sistema del paseo y generando tu QR de embarque.',
        step2: 'Reservando tu lugar en el paseo',
        step4: 'Generando tu QR de embarque',
        slow: 'Casi listo: el sistema del paseo está respondiendo. Puedes dejar esta página abierta.',
      },
      email: {
        subject: 'Reserva confirmada · Playas de Trindade · {{date}}',
        lead: 'Tu pago fue aprobado y tu reserva está confirmada. Guarda este email: el día del paseo solo tienes que mostrar el QR al guía.',
      },
    },
    en: {
      departure: 'Departure',
      pickupLabel: 'Pick-up',
      agencyLabel: 'Be at the agency',
      pickupPoint: 'Pick-up at',
      agencyPoint: 'Boarding at the agency',
      pickupPlaceDefault: 'Your lodging (central Paraty, up to 3 km from the agency)',
      agencyPlace: 'Paraty Sirena Tours agency – Av. Roberto Silveira, 578',
      howTitle: 'How the pick-up works',
      howTitleAgency: 'How boarding works',
      howHotel1: 'Be ready at your lodging from {{from}}: pick-ups run until {{departure}}.',
      howHotel2: 'The guide confirms on WhatsApp the exact time they come for you.',
      howAgency1: 'Be at the Paraty Sirena Tours agency (Av. Roberto Silveira, 578) at {{arrive}}, {{lead}} minutes before the {{departure}} departure.',
      howAgency2: 'At the agency, the guide checks the group in.',
      arriveHotel: 'Be ready from {{from}}: the jeep picks up at other lodgings on the way and leaves at {{departure}}.',
      arriveAgency: 'Be at the agency at {{arrive}} ({{lead}} minutes before departure): the jeep leaves at {{departure}} sharp.',
      tour: 'Trindade Beaches Tour',
      live: { closed: 'The jeep does not go out on this date. Please pick another date.' },
      intro: 'The best of Trindade in one day: Praia do Meio, Praia dos Ranchos, Praia do Cachadaço and the Natural Pool, ending at a cheese farm. Van and jeep with a local guide. About 6 hours.',
      qrHint: 'Show this code to the guide when boarding.',
      qrFailedHint: 'When boarding, the guide can also find your booking by the lead guest’s name.',
      qrOff: 'Show this ticket to the guide: they find your booking by the lead guest’s name.',
      how3: 'Show your QR to the guide when boarding and that’s it: Trindade’s beaches are waiting!',
      infoTab: 'Lunch is not included (restaurant at Praia dos Ranchos). The boat to the Natural Pool is optional and paid on site (R$ 25 each way); the trail there takes about 45 minutes.',
      infoWeather: 'The route may change with the weather or the sea. Bring swimwear, sneakers for an easy trail, sunscreen, a towel and water.',
      due: 'To pay on the day',
      openVoucher: 'Tour voucher',
      confirming: {
        subtitle: 'We’re registering your booking in the tour’s system and generating your boarding QR.',
        step2: 'Booking your place on the tour',
        step4: 'Generating your boarding QR',
        slow: 'Almost there: the tour’s system is responding. You can keep this page open.',
      },
      email: {
        subject: 'Booking confirmed · Trindade Beaches · {{date}}',
        lead: 'Your payment was approved and your booking is confirmed. Keep this email: on the day, just show the QR to the guide.',
      },
    },
    fr: {
      departure: 'Départ',
      pickupLabel: 'Prise en charge',
      agencyLabel: 'Arrivée à l’agence',
      pickupPoint: 'Prise en charge à',
      agencyPoint: 'Embarquement à l’agence',
      pickupPlaceDefault: 'Votre hébergement (centre de Paraty, jusqu’à 3 km de l’agence)',
      agencyPlace: 'Agence Paraty Sirena Tours – Av. Roberto Silveira, 578',
      howTitle: 'Comment se passe la prise en charge',
      howTitleAgency: 'Comment se passe l’embarquement',
      howHotel1: 'Soyez prêt à votre hébergement dès {{from}} : la prise en charge se fait jusqu’à {{departure}}.',
      howHotel2: 'Le guide vous confirme sur WhatsApp l’heure exacte de son passage.',
      howAgency1: 'Soyez à l’agence Paraty Sirena Tours (Av. Roberto Silveira, 578) à {{arrive}}, {{lead}} minutes avant le départ de {{departure}}.',
      howAgency2: 'À l’agence, le guide enregistre le groupe.',
      arriveHotel: 'Soyez prêt dès {{from}} : le jeep passe par d’autres hébergements en chemin et part à {{departure}}.',
      arriveAgency: 'Soyez à l’agence à {{arrive}} ({{lead}} minutes avant le départ) : le jeep part à {{departure}} précises.',
      tour: 'Balade aux plages de Trindade',
      live: { closed: 'Le jeep ne sort pas à cette date. Choisissez une autre date.' },
      intro: 'Le meilleur de Trindade en une journée : Praia do Meio, Praia dos Ranchos, Praia do Cachadaço et la Piscine naturelle, avec un dernier arrêt à la fromagerie. Van et jeep avec un guide local. Environ 6 heures.',
      qrHint: 'Montrez ce code au guide à l’embarquement.',
      qrFailedHint: 'À l’embarquement, le guide retrouve aussi votre réservation au nom du titulaire.',
      qrOff: 'Présentez ce billet au guide : il retrouve votre réservation au nom du titulaire.',
      how3: 'Montrez votre QR au guide à l’embarquement et c’est parti : les plages de Trindade vous attendent !',
      infoTab: 'Le déjeuner n’est pas inclus (restaurant à la Praia dos Ranchos). Le bateau jusqu’à la Piscine naturelle est facultatif et se paie sur place (R$ 25 par trajet) ; le sentier pour y aller prend environ 45 minutes.',
      infoWeather: 'L’itinéraire peut changer selon la météo ou la mer. Apportez maillot de bain, baskets pour un sentier facile, crème solaire, serviette et eau.',
      due: 'À payer le jour même',
      openVoucher: 'Voucher de la balade',
      confirming: {
        subtitle: 'Nous enregistrons votre réservation dans le système de la balade et générons votre QR d’embarquement.',
        step2: 'Réservation de votre place pour la balade',
        step4: 'Génération de votre QR d’embarquement',
        slow: 'Presque prêt : le système de la balade répond. Vous pouvez laisser cette page ouverte.',
      },
      email: {
        subject: 'Réservation confirmée · Plages de Trindade · {{date}}',
        lead: 'Votre paiement a été approuvé et votre réservation est confirmée. Gardez cet email : le jour J, il suffit de montrer le QR au guide.',
      },
    },
  },
};

const LANGS = ['pt', 'es', 'en', 'fr'];
const NESTED = ['confirming', 'email', 'review', 'live'];

const fill = (text, values) => String(text ?? '').replace(/\{\{(\w+)\}\}/g, (_, key) => values[key] ?? '');

/**
 * The ticket texts of a chey tour (a key of CHEY_TOURS) in a language: the shared ones with the tour's own on top.
 * A jeep tour's texts follow how the guest boards: `place` is the pick-up address they gave at checkout
 * (AGENCY_PICKUP when they board at the agency; empty when not known, which reads as a pick-up).
 */
export function ticketCopyFor(lang, tourKey, place = '') {
  const base = TICKET_COPY[LANGS.includes(lang) ? lang : 'pt'];
  const own = TOUR_COPY[tourKey]?.[LANGS.includes(lang) ? lang : 'pt'];
  if (!own) return base;
  const copy = { ...base, ...own };
  for (const key of NESTED) if (own[key]) copy[key] = { ...base[key], ...own[key] };
  const pickup = pickupFor(CHEY_TOURS[tourKey], place);
  if (!pickup) return copy;
  const agency = pickup.atAgency;
  const text = (hotelKey, agencyKey) => fill(copy[agency ? agencyKey : hotelKey], pickup);
  return {
    ...copy,
    checkin: agency ? copy.agencyLabel : copy.pickupLabel,
    checkinTime: agency ? pickup.arrive : `${pickup.from} – ${pickup.departure}`,
    meetingPoint: agency ? copy.agencyPoint : copy.pickupPoint,
    meetingPlace: agency ? copy.agencyPlace : pickup.place || copy.pickupPlaceDefault,
    howTitle: agency ? copy.howTitleAgency : copy.howTitle,
    how1: text('howHotel1', 'howAgency1'),
    how2: text('howHotel2', 'howAgency2'),
    infoArrive: text('arriveHotel', 'arriveAgency'),
  };
}

/** How every ticket email `lead` above opens, and how that opening reads for a booking nobody paid online. */
const PAID_OPENING = {
  pt: ['Seu pagamento foi aprovado e sua reserva está confirmada.', 'Sua reserva está confirmada.'],
  es: ['Tu pago fue aprobado y tu reserva está confirmada.', 'Tu reserva está confirmada.'],
  en: ['Your payment was approved and your booking is confirmed.', 'Your booking is confirmed.'],
  fr: ['Votre paiement a été approuvé et votre réservation est confirmée.', 'Votre réservation est confirmée.'],
};

/** The ticket email lead of a booking made with the team (nothing paid online): confirmed, no "payment approved". */
export function bookedLead(lead, lang) {
  const [paid, booked] = PAID_OPENING[LANGS.includes(lang) ? lang : 'pt'];
  return String(lead).replace(paid, booked);
}
